import React, { useState, useEffect } from "react";
import {Box, Paper, Grid, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Button, Stack, IconButton, } from '@mui/material';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { DataGrid } from "@mui/x-data-grid";
import PageLoader from "../../../components/Loader/PageLoader"
import DeleteIcon from '@mui/icons-material/Delete';
import HeaderName from "../../../components/Custom/HeaderName";
import { EditIcon } from "../../../components/Icons";
import { storeEditCustomerDetails } from "../../../redux/Slices/customerSlice";
import Swal from "sweetalert2";
import { deleteOfficeDetails, getOfficeList } from "../../../redux/Thunk/officeThunk";

const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
};

const DeliveryBoyList =() =>{
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loader, setLoader] = useState(false)
  const [totalCount, setTotalCount] = useState(0)
  const role = localStorage.getItem('role');
  const [selectedRows, setSelectedRows] = useState([]);
  const [search,setSearch] = useState('');
  const [officeList, setOfficeList] = useState([])
   const debouncedSearch = useDebounce(search, 500);
  // pagination
  const [page, setPage] = useState({
    page:0,
    pageSize:10
  })

  useEffect(()=>{
    fetchDeliveryBoy()
  },[page ,debouncedSearch])

  // get all Office details
  const fetchDeliveryBoy = async () => {
    setLoader(true)
    dispatch(getOfficeList({page: page.page + 1, limit: page.pageSize, search: debouncedSearch, role:'DeliveryBoy'})).then((res) => {
      setOfficeList(res?.payload?.data)
      setTotalCount(res?.payload?.total)
      setLoader(false)
    })
  };

  const handleRowSelection = (selection) => {
    if (selection?.length === 0) {
      // If no rows selected, clear the selected rows
      setSelectedRows([]);
    } else {
      // Map the selected IDs to their corresponding rows
      // const selectedRows = selection?.map(selectedId =>
      //   facilityList.find(row => row?._id === selectedId)
      // );
      setSelectedRows(selectedRows);
    }
  };

  // Edit Office details
  const handleClickEditDeliveryBoy =(details) =>{
    navigate('/dashboard/deliveryboylist/newdeliveryboy', {state:{editDetails:details}})
  }

  // Deleted Customer details
  const handleClickDeleteDeliveryBoy =(row) =>{
    Swal.fire({ 
      title: `Are you sure you want to delete the Delivery Boy ?`,
      showCancelButton: true,
      confirmButtonText: 'Delete',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: () => {
        return dispatch(deleteOfficeDetails({Id: row?.DeliveryBoyId, type:'DeliveryBoy'})).then((res)=>{
          if (res?.payload?.success === true && res?.payload?.warning === true) {
            Swal.fire('Warning!', res?.payload?.message, 'warning');
            fetchDeliveryBoy()
            setSelectedRows([])
          }else if(res?.payload?.success === true){
            Swal.fire('Deleted!', res?.payload?.message, 'delete');
            fetchDeliveryBoy()
            setSelectedRows([])
          }else{
            Swal.fire('Error!', res?.payload?.message, 'error');
          }
        });
      },
    });
  }

  const columns = [
    {
      flex: 0.1,
      minWidth: 80,
      field: 'Sr.No',
      align:'center',
      headerName: 'Sr. No',
      renderCell: params => {
        const { row } = params
  
        return (
          <Box sx={{ display: 'flex', padding:1, alignItems: 'center',justifyContent: 'center' }}>
            <Typography noWrap variant='body2' >
              {page?.page * page?.pageSize + params.api.getAllRowIds().indexOf(params.id)+1}
            </Typography>
          </Box>
        )
      }
    },
    {
      flex: 0.3,
      minWidth: 130,
      field: 'DeliveryBoyId',
      headerName: 'Id',
      align:'center',
      renderCell: params => {
        const { row } = params
  
        return (
          <Box sx={{ display: 'flex',alignItems:'center',justifyContent: 'center' }}>
            <Typography noWrap variant='body2' >
              {row?.DeliveryBoyId}
            </Typography>
          </Box>
        )
      }
    },
    {
      flex: 0.4,
      minWidth: 180,
      field: 'DeliveryBoyName',
      headerName: 'Name',
      align:'center',
      renderCell: params => {
        const { row } = params
  
        return (
          <Box sx={{ display: 'flex', alignItems: 'center',justifyContent: 'center' }}>
            <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
              {row?.AdminName || '--'}
            </Typography>
          </Box>
        )
      }
    },
    {
      flex: 0.4,
      minWidth: 150,
      field: 'Office Name',
      headerName: 'Office Name',
      align:'center',
      renderCell: params => {
        const { row } = params
  
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
              {row?.OfficeName || '--'}
            </Typography>
          </Box>
        )
      }
    }, 
    // {
    //   flex: 0.4,
    //   minWidth: 150,
    //   field: 'BranchName',
    //   headerName: 'Branch Name',
    //   align:'center',
    //   renderCell: params => {
    //     const { row } = params
  
    //     return (
    //       <Box sx={{ display: 'flex', alignItems: 'center' }}>
    //         <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
    //           {row?.BranchName || '--'}
    //         </Typography>
    //       </Box>
    //     )
    //   }
    // }, 
    {
      flex: 0.55,
      minWidth: 220,
      field: 'Email',
      align:'center',
      headerName: 'Email',
      renderCell: params => {
        const { row } = params
  
        return (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
              {row?.Email || '--'}
            </Typography>
          </Box>
        </>
        )
      }
    },
    {
      flex: 0.33,
      minWidth: 120,
      field: 'Mobile Number',
      align:'center',
      headerName: 'Mobile Number',
      renderCell: params => {
      const { row } = params
        return (<>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
            {row?.Mobile || '--'}
          </Typography>
        </Box>
        </>
        )
      }
    },
    {
      flex: 0.20,
      minWidth: 100,
      field: 'Status',
      align:'center',
      headerName: 'Status',
      renderCell: params => {
        const { row } = params
  
        return (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
              {row?.Status || '--'}
            </Typography>
          </Box>
        </>
        )
      }
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: 'Action',
      headerName: 'Action',
      align:'center',
      renderCell: params => {
        const { row } = params
  
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography noWrap variant='body2'>
                <IconButton id='edit' onClick={() => handleClickEditDeliveryBoy(row)}><EditIcon w={18} h={18} /></IconButton>
                <IconButton id='delete' onClick={()=> handleClickDeleteDeliveryBoy(row)}><DeleteIcon fontSize="medium" style={{color:'#04AB44'}}/></IconButton>
              </Typography>
            </Box>
          </Box>
        )
      }
    },    
  ]

    return(
      <>
        <div style={{display:'flex', flexDirection:'column', flexGrow: 1}}>
          {/* <Header /> */}
          { loader ? <PageLoader /> : 
            <Grid container style={{padding:'0px 10px', display:'flex', width:'97%', flexDirection:'row', justifyContent:'space-between'}}>   
              <Grid size={{ xs: 12, sm: 12, md: 12, lg:12 }}>
                <HeaderName headerName={'Delivery Boy List'} displaySearch = {true} newForm = {true} createNewForm={()=> navigate('/dashboard/deliveryboylist/newdeliveryboy')} onClickBackButton={()=> navigate("/dashboard")} 
                  setSearch ={setSearch} search={search}/>
                <div className="custom-data-grid-container_table">
                  <DataGrid
                    sx={{
                      borderRadius: "31px",
                      overflow: "auto",
                    }}
                    style={{ width: '100%' }}
                    pagination
                    // checkboxSelection
                    rows={officeList}
                    rowHeight={55}
                    rowCount={totalCount}
                    getRowId={param=> param._id}
                    columns={columns}
                    paginationModel={page}
                    sortingMode='server'
                    paginationMode='server'
                    pageSizeOptions={[10, 50, 100]}
                    onPaginationModelChange={(newPage)=>setPage(newPage)}
                    className="custom-data-grid"
                    selectionModel={selectedRows ? [selectedRows] : []}
                    onRowSelectionModelChange={handleRowSelection}
                    initialState={{
                      totalCount,
                      pagination: { paginationModel: {page:1, pageSize: 10}},
                    }}
                    disableRowSelectionOnClick
                    disableColumnMenu
                    disableColumnFilter
                    disableColumnSorting
                  />
                </div>
              </Grid>
            </Grid>
          }
        </div>
      </>
    )
}

export default DeliveryBoyList